import styled from 'styled-components';
import { Colors, fonts } from '../style/GlobalStyles';

const CTAButton = styled.button`
  font-family: ${fonts.body};
  padding: 1rem 2.2rem;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
  }
`;

// Botón sólido oscuro (sobre fondo crema)
const CTAButtonSolid = styled(CTAButton)`
  background: ${Colors.ink};
  color: ${Colors.paper};
  border: 1.5px solid ${Colors.ink};

  &:hover {
    background: ${Colors.lime};
    color: ${Colors.ink};
    border-color: ${Colors.lime};
  }
`;

function ButtonFill({ text, onClick }) {
  return <CTAButtonSolid onClick={onClick}>{text}</CTAButtonSolid>;
}

export { ButtonFill, CTAButtonSolid };
